import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CreditService {
  constructor(private http: HttpClient) {}

  public getUserCreditBalance(userId: number) {
    return this.http.get<any>(`credit/balance/${userId}`);
  }
}
